// extracted by mini-css-extract-plugin
export default {"terminator":"_1j777x6","description":"_9o1815","cta":"_14mkd8d","icon":"_1fwpycs"};